import axios from '@/lib/axios';
import { LostNonWarrantyRequestParams } from '../types';

const createLostNonWarranty = (data: LostNonWarrantyRequestParams) => {
  return axios.post(`/facility/facility_agreements/lost_non_warranty`, data);
}

export default createLostNonWarranty;